import {
  Level_INFO_getInstance24xg9wydggzl5 as Level_INFO_getInstance,
  Level_ERROR_getInstance253jkotxjexvf as Level_ERROR_getInstance,
} from './Level.mjs';
import { toStringSafe207d7m7lap1sq as toStringSafe } from './internal/MessageInvoker.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function info(message) {
  var tmp = Level_INFO_getInstance();
  return this.w2f(tmp, VOID, ($this$at) => {
    $this$at.r2f_1 = toStringSafe(message);
    return Unit_instance;
  });
}
function info_0(throwable, message) {
  var tmp = Level_INFO_getInstance();
  return this.w2f(tmp, VOID, ($this$at) => {
    $this$at.r2f_1 = toStringSafe(message);
    $this$at.s2f_1 = throwable;
    return Unit_instance;
  });
}
function error(throwable, message) {
  var tmp = Level_ERROR_getInstance();
  return this.w2f(tmp, VOID, ($this$at) => {
    $this$at.r2f_1 = toStringSafe(message);
    $this$at.s2f_1 = throwable;
    return Unit_instance;
  });
}
function at$default(level, marker, block, $super) {
  marker = marker === VOID ? null : marker;
  var tmp;
  if ($super === VOID) {
    this.z2f(level, marker, block);
    tmp = Unit_instance;
  } else {
    tmp = $super.z2f.call(this, level, marker, block);
  }
  return tmp;
}
var KLoggerClass;
function KLogger() {
  if (KLoggerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KLogger');
    KLoggerClass = $;
  }
  return KLoggerClass;
}
//region block: exports
export {
  at$default as at$default107kgtxirz58v,
  error as error12wpw0xi3o0bs,
  info_0 as info2hxv79dt541ps,
  info as info3uezdutu3rpr2,
  KLogger as KLogger368y32iihya1v,
};
//endregion

//# sourceMappingURL=KLogger.mjs.map
